export default function getDomainBotChat(){
    return `${process.env.REACT_APP_END_POINT_CHAT_BOT}`;
}